<div i18n class="description">Login as croupier to open table</div>
